import styled from 'styled-components'

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const DropdownPopup = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 160px;
  background: white;
  border: 1px solid var(--vo-cloud);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 1400;
  overflow-y: auto;
  max-height: 300px;
`

export const MenuItemButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: var(--vo-ink);
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: var(--vo-escuro-4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const MenuDivider = styled.div`
  height: 1px;
  background: var(--vo-cloud);
  margin: 4px 0;
`
